import React from 'react';
import ProductItem from '../../../../shared/components/ProductItem/Index';

import './styles.css';

export default function Index(props) {

    if (props.items?.length === 0)
        return null;

    return (
        <div className='container mb-20'>
            <h2 className="pb-2 border-bottom mt-5">Productos Descatados</h2>
            <div className="row">
                {
                    props.items?.map(item => <ProductItem key={item.id} item={item} columns={4}/>)
                }
            </div>
        </div>
    );
}